import { request } from 'utils/tool';
import { PREFIX } from 'constants/host';
import Notify from 'ui-component/Tools/Notify';
import { getResult } from './common';

export const uploadFile = async (options: any) => {
  const res = getResult<any>(await request.post(`${PREFIX}/file/upload`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const uploadFileWaterFile = async (options: any) => {
  const res = getResult<any>(await request.post(`${PREFIX}/file/upload/id`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};

export const uploadFileWaterFileOcr = async (options: any) => {
  const res = getResult<any>(await request.post(`${PREFIX}/file/upload/id/ocr`, options));
  if (!res.success) {
    Notify('error', res.msg);
  }
  return res;
};
